/*
 * @Author: Hyman Choi
 * @Date: 2021-01-08 15:19:52
 * @LastEditTime: 2022-01-27 10:17:56
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Siui.Cloud.Medical.Web\src\router\Modules\mai.js
 */
import Layout from "@/layout";
import {
	getRoleProd,
	getRoleAbroad
} from "@/router/roleHandler"
import config from "@/utils/config"

const maiRouter = {
	path: "/cloud_maili_page",
	component: Layout,
	redirect: "/cloud_maili_page/live_review_page",
	name: "mai",
	meta: {
		roles: ["超级管理员", '系统管理员', 'Super Admin'],
		title: "mai",
		icon: "doctor",
	},
	children: [{
			path: "previewResource",
			name: "previewResource",
			component: () => import("@/views/mai/previewResource/index"),
			meta: {
				roles: ["超级管理员"],
				title: "previewResource",
			},
		},
		{
			path: "productionDetail",
			name: "productionDetail",
			component: () => import("@/views/mai/previewResource/productionDetail"),
			meta: {
				roles: ["超级管理员"],
				title: "productionDetail",
			},
			hidden: true,
		},
		{
			path: "live_review_page",
			name: "live_review_page",
			component: () => import("@/views/mai/liveReview/index"),
			meta: {
				roles: ["超级管理员", '系统管理员', 'Super Admin'],
				title: "liveReview",
			},
		},
		{
			path: "liveReviewDetail",
			name: "liveReviewDetail",
			parent: ["live_review_page"],
			component: () => import("@/views/mai/liveReview/reviewDetail/index"),
			meta: {
				roles: ["超级管理员", '系统管理员', 'Super Admin'],
				title: "往期回顾详情",
			},
			hidden: true,
		},
		{
			path: "video_case_page",
			name: "video_case_page",
			component: () => import("@/views/mai/videoCourse/index"),
			meta: {
				roles: ["超级管理员", '系统管理员', 'Super Admin'],
				title: "videoCourse",
			},
		},
		{
			path: "videoDetail",
			name: "videoDetail",
            parent: ["video_case_page"],
			component: () => import("@/views/mai/videoCourse/videoDetail/index"),
			meta: {
				roles: ["超级管理员", '系统管理员', 'Super Admin'],
				title: "videoDetail",
			},
			hidden: true,
		},
		{
			path: "uploadManage",
			name: "uploadManage",
            parent: ["video_case_page","live_review_page"],
			component: () => import("@/views/uploadManager/uploadManagerVC"),
			meta: {
				roles: ["超级管理员", '系统管理员', 'Super Admin'],
				title: "上传记录",
			},
			hidden: true,
		},
		{
			path: "forum_page",
			name: "forum_page",
			component: () => import("@/views/mai/ultrasonic/index"),
			meta: {
				roles: ["超级管理员",
					getRoleProd(config.SHOW_ULTRASONIC),
					getRoleAbroad(config.SHOW_ULTRASONIC)
				],
				title: "ultrasonic",
			},
		},
		{
			path: "ultrasonicDetail",
			name: "ultrasonicDetail",
			parent: ["forum_page"],
			component: () => import("@/views/mai/ultrasonic/ultrasonicDetail/index"),
			meta: {
				roles: ["超级管理员",
					getRoleProd(config.SHOW_ULTRASONIC),
					getRoleAbroad(config.SHOW_ULTRASONIC)
				],
				title: "ultrasonicDetail",
				activeMenu: "/cloud_maili_page/forum_page",
			},
			hidden: true,
		},
		{
			path: "ultrasonicGroupsDetail",
			name: "ultrasonicGroupsDetail",
			parent: ["forum_page"],
			component: () =>
				import("@/views/mai/ultrasonic/ultrasonicGroupsDetail/index"),
			meta: {
				roles: ["超级管理员",
					getRoleProd(config.SHOW_ULTRASONIC),
					getRoleAbroad(config.SHOW_ULTRASONIC)
				],
				title: "ultrasonicGroupsDetail",
				activeMenu: "/cloud_maili_page/forum_page",
			},
			hidden: true,
		},
		{
			path: "ultrasonicGroupsMember",
			name: "ultrasonicGroupsMember",
			parent: ["forum_page"],
			component: () =>
				import("@/views/mai/ultrasonic/ultrasonicGroupsMember/index"),
			meta: {
				roles: ["超级管理员",
					getRoleProd(config.SHOW_ULTRASONIC),
					getRoleAbroad(config.SHOW_ULTRASONIC)
				],
				title: "ultrasonicGroupsMember",
				activeMenu: "/cloud_maili_page/forum_page",
			},
			hidden: true,
		},
		{
			path: "ultrasonicGroupsPost",
			name: "ultrasonicGroupsPost",
			parent: ["forum_page"],
			component: () =>
				import("@/views/mai/ultrasonic/ultrasonicGroupsPost/index"),
			meta: {
				roles: ["超级管理员",
					getRoleProd(config.SHOW_ULTRASONIC),
					getRoleAbroad(config.SHOW_ULTRASONIC)
				],
				title: "ultrasonicGroupsPost",
				activeMenu: "/cloud_maili_page/forum_page",
			},
			hidden: true,
		},

		{
			path: "eventSquare",
			name: "eventSquare",
			component: () => import("@/views/mai/eventSquare/index"),
			meta: {
				roles: ["超级管理员"],
				title: "eventSquare",
			},
		},
		{
			path: "eventDetail",
			name: "eventDetail",
			component: () => import("@/views/mai/eventSquare/eventDetail/index"),
			meta: {
				roles: ["超级管理员"],
				title: "eventDetail",
				activeMenu: "/mai/eventSquare",
			},
			hidden: true,
		},
		{
			path: "hierarchicalDiagnosis",
			name: "hierarchicalDiagnosis",
			component: () => import("@/views/mai/hierarchicalDiagnosis/index"),
			meta: {
				roles: ["超级管理员"],
				title: "hierarchicalDiagnosis",
			},
		},
		{
			path: "netDiskDetail",
			name: "netDiskDetail",
			parent: ["forum_page"],
			component: () => import("@/views/systemManagement/netDisk/user/index"),
			meta: {
				roles: ["超级管理员",
					getRoleProd(config.SHOW_ULTRASONIC)
				],
				title: "netDiskDetail",
				activeMenu: "/cloud_maili_page/forum_page",
			},
			hidden: true,
		},

	],
};

export default maiRouter;
